export interface Pagination<T> {
  items: T[];
  pagination_metadata?: PaginationMetadata;
}

export interface PaginationMetadata {
  page: number;
  page_size: number;
  page_count: number;
  total_items: number;
  previous?: number;
  next?: number;
}

export interface IPaginationMetadataViewModel {
  page: number;
  pageSize: number;
  pageCount: number;
  totalItems: number;
  totalPages: number;
  previous?: number;
  next?: number;
}
export class PaginationMetadataViewModel
  implements IPaginationMetadataViewModel
{
  static fromJSON(json: PaginationMetadata): PaginationMetadataViewModel {
    const totalPages = Math.ceil(json.total_items / json.page_size);

    const previous = json.page - 1 || undefined;
    const next = totalPages > json.page ? json.page + 1 : undefined;

    return new PaginationMetadataViewModel(
      json.page,
      json.page_size,
      json.page_count,
      json.total_items,
      totalPages,
      previous,
      next,
    );
  }
  constructor(
    public page: number,
    public pageSize: number,
    public pageCount: number,
    public totalItems: number,
    public totalPages: number,
    public previous?: number,
    public next?: number,
  ) {}
}
